<div class="step-circle opened-nav" id="cn-wrapper"
     [ngClass]="getCircleActiveState()">
    <div class="circle-background" [ngStyle]="getCircleBackground()"></div>
    <ul>
      <li *ngFor="let item of numberOfArcs; let i = index;"
          [ngStyle]="getArcDimensions(i)">
        <a><span class="step-progress-arc"></span></a>
      </li>
    </ul>
</div>
